module.exports = __webpack_public_path__ + "img/facebook.317bf47e.png";